import React from 'react'
import { Modal } from '@mui/material'
import Fade from '@mui/material/Fade'

import View from '@modul-connect/shared/components/atoms/view'
import { H1, P } from '@modul-connect/shared/components/atoms/text'
import Button from '@modul-connect/shared/components/atoms/button'
import modal from '@modul-connect/shared/components/atoms/modal'


const ModalRemoveItem = ({
  openModal,
  onClose,
  onSubmit,
  header,
  content,
  disabled,
  action
}) => {
  return (
    <Modal
      open={ openModal }
      onClose={(event, reason) => {
        if (disabled && reason === 'backdropClick') {
          return
        }
        onClose()
      }}            
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Fade in={ openModal }>
        <div >
          <View extend={ modal.container }>
            <View extend={ modal.header }>
              <H1 text={ header }/>
            </View>
            <View extend={ modal.content }>
              <P>{ content }</P>
            </View>
            <View extend={ modal.footer }>
              <Button noBg disabled={ disabled } cancel onClick={ () => onClose() }>
                                Cancel
              </Button>
              <Button noBg issue disabled={ disabled } noPadding onClick={ onSubmit }>
                {action || 'Remove'}
              </Button>
            </View>
          </View>
        </div>
      </Fade>
    </Modal>
  )
}

export default ModalRemoveItem